export const suggestedPromptVariants = {
  prefill: 'prefill',
  autosend: 'autosend',
} as const;

export type SuggestedPromptVariant =
  (typeof suggestedPromptVariants)[keyof typeof suggestedPromptVariants];

export interface SmartCartAgentSuggestedPrompt {
  label: string;
  type: SuggestedPromptVariant;
}

export interface SmartCartAgentInitResponse {
  welcomeText: string;
  introText: string;
  suggestedPrompts: SmartCartAgentSuggestedPrompt[];
  conversationId: string;
}

/**
 * Surface the customer opened the chat from. Sodapop selects the starter
 * prompts from this; unrecognized values fall back to its generic set rather
 * than failing the request.
 */
export const agentSurfaces = {
  home: 'home',
  search: 'search',
  cookbook: 'cookbook',
  orders: 'orders',
} as const;

export type AgentSurface = (typeof agentSurfaces)[keyof typeof agentSurfaces];

/** Orders sub-tab, only meaningful when `surface` is `orders`. */
export const agentOrderTabs = {
  current: 'current',
  upcoming: 'upcoming',
  delivered: 'delivered',
} as const;

export type AgentOrderTab =
  (typeof agentOrderTabs)[keyof typeof agentOrderTabs];
